import Notifications from '@admin/components/notifications'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import Dashboard from '@apps/dashboards/admin/components/dashboard'
import StackRouter from '@admin/components/stack_router'
import Timezone from '@admin/components/timezone'
import Greeting from '@admin/components/greeting'
import Verify from '@admin/components/verify'
import Prompt from '@admin/components/prompt'
import Button from '@admin/components/button'
import Ribbon from '@admin/components/ribbon'
import { getCode } from '@core/utils/codes'
import Tasks from '@admin/components/tasks'
import Modal from '@admin/components/modal'
import Error from '@admin/components/error'
import Push from '@admin/components/push'
import Help from '@admin/components/help'
import PropTypes from 'prop-types'
import React from 'react'

export const PortalContext = React.createContext(null)
PortalContext.displayName = 'PortalContext'

class Portal extends React.Component {

  static childContextTypes = {
    portal: PropTypes.object
  }

  static contextTypes = {
    admin: PropTypes.object,
    host: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {}

  state = {
    drawer: null,
    sidebar: null,
    help: false
  }

  _handleSetDrawer = this._handleSetDrawer.bind(this)
  _handleSetSidebar = this._handleSetSidebar.bind(this)
  _handleToggleHelp = this._handleToggleHelp.bind(this)

  render() {
    const { admin } = this.context
    const { drawer, help, sidebar } = this.state
    const { team, user } = admin
    const Body = admin.hasRights({ allOf: ['dashboards:access_app'] }) ? Dashboard : Greeting
    if(!team || !user) return null
    return (
      <PortalContext.Provider value={ this.getChildContext() }>
        <div className={ this._getClass() }>
          <Notifications>
            <Push>
              <Modal>
                <Prompt>
                  <Verify>
                    <Modal>
                      <Tasks>
                        <Timezone>
                          <div className="maha-portal-frame">
                            <div className="maha-portal-ribbon">
                              <Ribbon />
                            </div>
                            <div className="maha-portal-main">
                              <div className="maha-portal-sidebar">
                                <TransitionGroup component={ null }>
                                  { sidebar &&
                                    <CSSTransition key={ sidebar.id } classNames="sidebar" timeout={ 250 } mountOnEnter={ true } unmountOnExit={ true } >
                                      <Error>
                                        { React.createElement(sidebar.component) }
                                      </Error>
                                    </CSSTransition>                              
                                  }
                                </TransitionGroup>
                              </div>
                              <div className="maha-portal-body">
                                <Body />
                                <StackRouter />
                              </div>
                              <div className="maha-portal-help">
                                <TransitionGroup component={ null }>
                                  { help &&
                                    <CSSTransition key="help" classNames="help" timeout={ 250 } mountOnEnter={ true } unmountOnExit={ true } >
                                      <Help { ...this._getHelp() } />
                                    </CSSTransition>                              
                                  }
                                </TransitionGroup>
                              </div>
                              <CSSTransition in={ drawer !== null } classNames="fade-in-half" timeout={ 250 } mountOnEnter={ true } unmountOnExit={ true }>
                                <Button { ...this._getOverlay() } />
                              </CSSTransition>
                              <TransitionGroup component={ null }>
                                { drawer &&
                                  <CSSTransition  key={ drawer.id } classNames="slide-in-right" timeout={ 250 } mountOnEnter={ true } unmountOnExit={ true } >
                                    <div { ...this._getDrawer(drawer) }>
                                      <Error>
                                        { React.createElement(drawer.component) }
                                      </Error>
                                    </div>
                                  </CSSTransition>                              
                                }
                              </TransitionGroup>
                            </div>
                          </div>
                        </Timezone>
                      </Tasks>
                    </Modal>
                  </Verify>
                </Prompt>
              </Modal>
            </Push>
          </Notifications>
        </div>
      </PortalContext.Provider>
    )
  }

  componentDidMount() {
    this.context.host.device.setCount(0)
  }

  getChildContext() {
    return {
      portal: {
        setDrawer: this._handleSetDrawer,
        setSidebar: this._handleSetSidebar,
        toggleHelp: this._handleToggleHelp
      }
    }
  }

  _getClass() {
    const { help, sidebar } = this.state
    const classes = ['maha-portal']
    if(sidebar !== null) classes.push('sidebar')
    if(help) classes.push('help')
    return classes.join(' ')
  }

  _getDrawer(drawer) {
    return {
      className: 'maha-portal-drawer',
      style: { maxWidth: drawer.width }
    }
  }

  _getHelp() {
    return {
      onCancel: this._handleToggleHelp
    }
  }

  _getOverlay() {
    return {
      label: null,
      className: 'maha-portal-overlay',
      event: 'closed navigation',
      handler: this._handleSetDrawer.bind(this, null)
    }
  }

  _handleSetDrawer(component, width = 350) {
    const { drawer } = this.state
    this.setState({ 
      drawer: component && component !== drawer?.component ? { 
        id: getCode(5), 
        component, 
        width 
      } : null
    })
  }

  _handleSetSidebar(component) {
    const { sidebar } = this.state
    this.setState({ 
      sidebar: component && component !== sidebar?.component ? { 
        id: getCode(5), 
        component
      } : null
    })
  }

  _handleToggleHelp() {
    console.log('toggle help')
    const { help } = this.state
    this.setState({ 
      help: !help
    })
  }

}

export default Portal
